import React from 'react';

const Footer: React.FC = () => {
    return (
        <footer className="footer">
            <div className="footer-content">
                {/*<nav className="footer-nav">*/}
                {/*    <a href="/privacy">Privacy Policy</a>*/}
                {/*    <a href="/terms">Terms of Service</a>*/}
                {/*    <a href="/contact">Contact Us</a>*/}
                {/*</nav>*/}
            </div>
        </footer>
    );
};

export default Footer;
